import { Controller /* useFormContext */ } from 'react-hook-form'

import { IUnitProps } from './interface'
import { Multi } from '@/components/select/multi'

const Unit = ({ control, accountKey, loadOptions }: IUnitProps) => {
  return (
    <Controller
      key={accountKey}
      name='unidade'
      control={control}
      render={({ field: { onChange, value } }) => (
        <Multi
          value={value}
          onChange={onChange}
          label='Unidade'
          loadOptions={loadOptions}
        />
      )}
    />
  )
}

export default Unit
